export default __webpack_public_path__ + "static/bannerbox.eglo.pim-8264646559f37bd0e6b68418ccc38455.jpg";